"use strict";

angular.module("core")
.component("statusInline", {
    templateUrl: require("./status-inline.component.html"),
    bindings: {
        status: "<",
        statusDate: "<?",
        service: "<",
        ignoreNoWrap: "<?"
    },
    controller: StatusInlineController
});

function StatusInlineController() {
    this.getStatusName = function(status) {
        return this.service.getStatusName(status);
    };
}



//////////////////
// WEBPACK FOOTER
// ./core/status-inline/status-inline.component.js
// module id = 609
// module chunks = 0